import { Injectable, OnDestroy } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ReplaySubject } from 'rxjs';
import { AllDeviceInfo } from '@interfaces';
import { DeviceInfoService } from '@core/services/device-info.service';
import { takeUntil } from 'rxjs/operators';
import { IntroModalComponent } from '@shared/intro-modal/intro-modal.component';
import { DataListingRequestModalComponent } from './data-listing-request-modal.component';

@Injectable({
  providedIn: 'root',
})
export class DataListingRequestModalService implements OnDestroy {
  public dialogRef: MatDialogRef<any>;
  public name = 'request-own-data-modal';

  private destroy$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  public deviceInfo: AllDeviceInfo;
  private dialogWidth = '600px';

  public password: string;

  constructor(
    private dialog: MatDialog,
    private readonly deviceInfoService: DeviceInfoService
  ) {
    this.deviceInfo = this.deviceInfoService.getInfo();
    this.deviceInfoService.infoEmitter.pipe(takeUntil(this.destroy$)).subscribe(info => {
      this.deviceInfo = info;
      if (this.deviceInfo.deviceTypeDetected === 'PHONE') {
        this.dialogWidth = '95vw';
      }
    });
    if (this.deviceInfo.deviceTypeDetected === 'PHONE') {
      this.dialogWidth = '95vw';
    }
  }

  public open(): MatDialogRef<IntroModalComponent> {
    this.dialogRef = this.dialog.open(DataListingRequestModalComponent, {
      width: this.dialogWidth,
      maxWidth: this.dialogWidth,
      panelClass: ['request-own-data-modal'],
      autoFocus: false,
      data: { password: this.password },
      id: this.name,
      backdropClass: this.name + '_backdrop',
    });

    return this.dialogRef;
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.complete();
  }
}
